import React, { useState, useEffect } from "react";
import { Spinner, Flex, Icon } from "@storyofams/react-ui";
import * as loadImage from "blueimp-load-image";

import {
  FixedRatio,
  Button,
  Image as StyledImage,
} from "../../../../../components";
import { Cross } from "../../../../../components/common/Icons";

export const ImageWrapper = ({
  src = undefined,
  children = null,
  ...props
}) => (
  <FixedRatio
    position="relative"
    align-items="center"
    justify-content="center"
    border="1px"
    borderColor="grey400"
    borderRadius="sm"
    overflow="hidden"
    {...props}
  >
    {src && (
      <StyledImage
        src={src}
        width="100%"
        height="100%"
        layout="fill"
        objectFit="cover"
      />
    )}
    {children}
  </FixedRatio>
);

export const readFile = (file, cb) => {
  if (file.type.includes("image")) {
    return loadImage(file, (canvas) => cb(canvas.toDataURL()), {
      orientation: true,
      canvas: true,
    });
  }
  const reader = new FileReader();
  reader.onload = (readerEvent) => {
    cb(reader.result);
  };

  reader.readAsDataURL(file);
};

export const FilePreview = ({ file, onRemove, ...props }) => {
  const [src, setSrc] = useState("");
  const [videoSrc, setVideoSrc] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!file) return setSrc("");

    if (typeof file !== "string") {
      setLoading(true);

      readFile(file, onReadComplete);
    } else {
      imageExists(file, () => {
        setSrc(file);
      });
    }
  }, [file]);

  const imageExists = (url, cb) => {
    const img = new Image();
    img.onload = () => cb();
    img.src = url;
  };

  const onReadComplete = (url) => {
    setLoading(false);
    setSrc(url);
    if (file.type.includes("video")) {
      setVideoSrc(url);
    }
  };
  return (
    <ImageWrapper {...props}>
      {loading && <Spinner />}

      {!!src && !loading && (
        <Flex position="relative" width="100%" height="100%">
          <Button
            type="button"
            variant="unstyled"
            onClick={() => onRemove(file.name)}
            position="absolute"
            top="2px"
            right="2px"
            zIndex={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
            size={30}
            bg="white"
            borderRadius="full"
            boxShadow="sm"
          >
            <Icon icon={Cross} fontSize={2} />
          </Button>

          {file.type.includes("video") ? (
            <video src={videoSrc} />
          ) : (
            <StyledImage
              src={src}
              width="100%"
              height="100%"
              layout="fill"
              objectFit="cover"
            />
          )}
        </Flex>
      )}
    </ImageWrapper>
  );
};
